export const Books1 = `<div class=" common-details">
<div class="common-image"></div>
<div class="common-title"></div>
<div class="common-authors"></div>
</div>`;
